import { useTranslation } from 'react-i18next';
import type { Contact } from '@/entities/contacts';

interface ContactDetailsProps {
  contact: Contact;
}

export const ContactDetails = ({ contact }: ContactDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 p-4 rounded-lg bg-green-50 border border-green-100 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
            {t('contacts.fields.fullNameJobTitle', "Person's full name / Job Title")}
          </div>
          <div className="text-sm font-medium text-slate-700">
            {contact.name} {contact.jobTitle ? `/ ${contact.jobTitle}` : ''}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
              {t('contacts.fields.email', 'Email')}
            </div>
            <div className="text-sm font-medium text-slate-600 break-all">{contact.email || contact.email1 || '-'}</div>
          </div>
          <div>
            <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">
              {t('contacts.fields.phone', 'Phone')}
            </div>
            <div className="text-sm font-medium text-slate-600">{contact.phone || contact.phone1 || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
